import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { selectConnectToken } from '@epicuro-next/state/connect-token-state';
import { select, Store } from '@ngrx/store';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConnectInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    if (!request.url.startsWith('/api/v2/connect')) {
      return next.handle(request);
    }
    return this.store.pipe(
      select(selectConnectToken),
      take(1),
      switchMap((token: string) => {
        if (!token) {
          return next.handle(request);
        }
        const headers = request.headers.set(
          'Epc-Connect-Token',
          `Bearer ${token}`,
        );
        request = request.clone({
          headers,
        });
        return next.handle(request);
      }),
    );
  }
}
